import React from "react";
import ReactECharts from "echarts-for-react";
import { Spin, Empty } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

interface TaskProgressBarChartProps {
  loading: boolean;
  chartData: {
    completionPercentages: string[]; // e.g. ["0%", "10%", ..., "100%"]
    taskCounts: number[];
  } | null;
}

const barColors = [
  "#7ecbff", // 0%
  "#4096d0", // 10%
  "#3390a5", // 20%
  "#4fbba3", // 30%
  "#ff8a8a", // 90%
  "#a64b2a", // 100%
];

const TaskProgressBarChart: React.FC<TaskProgressBarChartProps> = ({ loading, chartData }) => {
  const getChartOptions = () => {
    if (!chartData) return {};

    return {
      animationDuration: 800,
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      grid: {
        top: 20,
        left: 30,
        right: 20,
        bottom: 25,
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: chartData.completionPercentages,
        name: "Completion Percentage",
        nameLocation: "middle",
        nameGap: 30,
      },
      yAxis: {
        type: "value",
        name: "Task Count",
        nameLocation: "middle",
        nameGap: 30,
      },
      series: [
        {
          data: chartData.taskCounts.map((count, index) => ({
            value: count,
            itemStyle: { color: barColors[index] || "#1890ff" },
          })),
          type: "bar",
          barWidth: 24,
        },
      ],
    };
  };

  if (loading) {
    return (
      <div style={{ height: 260, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
      </div>
    );
  }

  if (!chartData || chartData.completionPercentages.length === 0) {
    return (
      <div style={{ height: 260, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Empty description="No data found" />
      </div>
    );
  }

  return (
    <ReactECharts
      option={getChartOptions()}
      style={{ height: 260, width: "100%" }}
      notMerge={true}
      lazyUpdate={true}
    />
  );
};

export default TaskProgressBarChart;
